export function extractTablesFromHTML(html: string): string[][][] {
  if (typeof document === 'undefined' || !('createElement' in document)) {
    return []
  }

  const template = document.createElement('template')
  template.innerHTML = html.trim()

  const tableElements = template.content.querySelectorAll('table')
  const allTablesData: string[][][] = []

  for (const tableElement of tableElements) {
    const currentTableData: string[][] = []
    const rows = tableElement.rows

    for (const row of rows) {
      const rowData: string[] = []
      const cells = row.cells

      for (const cell of cells) {
        rowData.push(cell.textContent?.trim() || '')
      }
      currentTableData.push(rowData)
    }
    allTablesData.push(currentTableData)
  }

  return allTablesData
}
